import CustomTabPanel from "components/Shared/CustomTabPanel";
import CustomTabs from "components/Shared/CustomTabs";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import { useMunicipalityDetailContext } from "contexts/LocationContexts/MunicipalityDetailContext";
import { useSearchParams } from "react-router-dom";
import WardsTab from "./WardsTab";
import LinkedBranchesTab from "./LinkedBranchesTab";

export const MunicipalityDetailTabs = () => {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "branches";
  const { municipalityDetail, loadingDetail } = useMunicipalityDetailContext();

  const tabs = [
    {
      label: "Wards",
      value: "wards",
    },
    {
      label: "Linked Branches",
      value: "branches",
    },
  ];
  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {!loadingDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="wards">
            <WardsTab municipalityDetail={municipalityDetail} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="branches">
            <LinkedBranchesTab municipalityDetail={municipalityDetail} />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default MunicipalityDetailTabs;
